import { render } from "./HeadingTooltip.vue?vue&type=template&id=31f93db8"
import script from "./HeadingTooltip.vue?vue&type=script&lang=js"
export * from "./HeadingTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__